import { showAction } from '../../../actions/fs_remove_light_box_actions';

const onRemoveStationClick = () => {
    showAction();
};

export default onRemoveStationClick;